import React, { Component } from 'react';

import Section from './Section';

export default class Debug extends Component {
    renderToken(key) {
        const json = localStorage.getItem('token.' + key);
        if (!json) return null;

        let str = json;
        try {
            str = <pre>{JSON.stringify(JSON.parse(json), null, 2)}</pre>;
        } catch (e) {

        }

        return <Section key={key} title={key}>{str}</Section>;
    }

    render() {
        return [ 'blizzard', 'patreon', 'twitch', 'jwt' ].map(key => this.renderToken(key));
    }
}